<script setup lang="ts">
import { WikiMagazineProps } from "./WikiMagazine.props"

withDefaults(defineProps<WikiMagazineProps>(), {
  subtitle: "",
  text: "",
  isPromotion: false
})
</script>

<template>
  <div class="negative-margined md:grid-container md:mx-0">
    <div
      class="
        wiki-magazine-wrapper
        relative
        col-span-full
        flex flex-col
        justify-center
        gap-4
        px-4
        py-6
        md:items-center
      "
    >
      <UtilsWrapperImage
        v-if="bgImage"
        v-bind="bgImage"
        :key="bgImage.image.url"
        sizes="600px md:800px lg:1600px xl:2000px"
        class="
          wrapper-image-full-container-centered
          absolute
          inset-0
          -z-10
          overflow-hidden
        "
      />

      <h1
        v-if="title"
        class="md:mammoth-bold"
        :class="isPromotion ? 'hyppo-bold' : 'elephant-bold'"
      >
        {{ title }}
      </h1>

      <UtilsMarkdown
        v-if="subtitle"
        :class="
          isPromotion ? 'pig-medium text-black-80' : 'pig text-black-main'
        "
        :content="subtitle"
      />

      <div v-if="text" class="grid-container grid-cols-12">
        <UtilsMarkdown
          class="
            beaver
            col-span-full
            md:col-span-8 md:col-start-3
            lg:col-span-6 lg:col-start-4
          "
          :class="isPromotion ? 'text-black-80' : 'text-black-main'"
          :content="text"
        />
      </div>
    </div>
  </div>
</template>
